import { getObjectUtil } from 'packages/src'
import { START_WORKOUT_PATH } from '../../constants'
import { createSelector } from 'reselect'

const getCurrentWorkoutExerciseIndexStartWorkoutSelect = createSelector(
  state => getObjectUtil(state, START_WORKOUT_PATH.CURRENT_WORKOUT_EXERCISE_INDEX),
  (workoutSection) => workoutSection
)

export default getCurrentWorkoutExerciseIndexStartWorkoutSelect
